import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';

export const auditoryContainer = style({
  display: 'flex',
  gap: space.s16,
});

export const auditoryItem = style({
  ...typography['bodyMd'],

  color: themeVars.container.foreground.primary,

  display: 'flex',
  gap: space.s3,
  ':hover': {
    textDecoration: 'underline',
  },
});

export const auditoryNumber = style({
  fontWeight: fontWeight.semibold,
});
